/** Enumeration of base callout component types */
export enum CalloutComponentBaseType {
  CONTENT,
  INPUT,
  INPUT_TEXT,
  INPUT_SELECTABLE,
  NESTABLE,
}
